export function getParentStateName(state) {
  return state.parent || (state.name.match(/\./) && state.name.split(/\./)[0]);
}

export let setPageTitle = angular.noop;

export const stateSpecificComponentModule = angular
  .module('Q.components.state-specific', [])

  .factory('titleFormatter', function () {
    let separator = ' - ';
    return function (baseTitle, pageTitle) {
      const titles = [].concat(pageTitle || []);
      titles.unshift(baseTitle);
      return titles.reverse().join(separator);
    };
  })

  .directive('body', function () {
    let bodyClass;
    return {
      restrict: 'E',
      link: function (scope, el) {
        scope.$on('$stateChangeSuccess', function (evt, toState) {
          if (bodyClass) {
            el.removeClass(bodyClass);
          }
          bodyClass = toState.data && toState.data.bodyClass;
          if (bodyClass) {
            el.addClass(bodyClass);
          }
        });
      },
    };
  })

  .directive('title', function (titleFormatter, $injector) {
    let baseTitle;
    return {
      restrict: 'E',
      link: function (scope, el) {
        baseTitle = [el.text()];
        setPageTitle = (pageTitle) => {
          el.text(titleFormatter(baseTitle, pageTitle));
        };
        scope.$on('$stateChangeSuccess', function (evt, toState) {
          let pageTitle = toState.data && toState.data.pageTitle;
          if (pageTitle && !angular.isString(pageTitle)) {
            pageTitle = $injector.invoke(pageTitle);
          }

          setPageTitle(pageTitle);
        });
      },
    };
  })
  .factory('nestedPageTitleHelper', function ($state, $injector) {
    function getTitle(val) {
      if (!angular.isString(val)) {
        val = $injector.invoke(val);
      }
      return val;
    }

    return function (myState, myTitle) {
      const current = $state.get(myState);
      const currentTitle = getTitle(myTitle);
      const parentName = getParentStateName(current);
      const parent = parentName ? $state.get(parentName) : false;
      let parentTitle = [];
      if (parent && parent.data && parent.data.pageTitle) {
        parentTitle = getTitle(parent.data.pageTitle);
      }
      return [].concat(parentTitle, currentTitle);
    };
  });
